import axios from 'axios';
import Swal from "sweetalert2";

export const refreshPageMixin = {
  data() {
    return {
      currentHash: this.$appVersion,
      hashChanged: false,
      newHash: '',
      alertShown: false,
      loading: false,
      errorStatus: ''
    }
  },

  mounted(){
    const isProd = (window.webpackHotUpdateposnet_portal_klienta===undefined);
    if (isProd) {
        this.initVersionCheck('/version.json');
    }
  },

  methods: {
    initVersionCheck(url, frequency = 1000 * 60 * 2) {
      setInterval(() => {
        this.checkVersion(url);
      }, frequency);
    },

    async checkVersion(url) {
      try {
        const fileResponse = await axios.get(url, { headers: { 'Cache-Control': 'no-cache' } });

        this.newHash = fileResponse.data.version;

        this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash);
      } catch (error) {
        this.loading = false;
        if (!error.response) {
          this.errorStatus = 'Error: Network Error'
        } else {
          this.errorStatus = error.response.data.message;
        }
      }
    },

    hasHashChanged(currentHash, newHash) {
      if (!currentHash || currentHash !== newHash) {
        if (!this.alertShown) {
          this.alertShown = true;
          Swal.fire({
              title: "Ważne!",
              // icon: "warning",
              showCancelButton: true,
              reverseButtons: true,
              confirmButtonColor: '#4ea852',
              cancelButtonColor: '#f33527',
              confirmButtonText: "Aktualizuj",
              cancelButtonText: "Anuluj",
              buttonsStyling: true,
              html: `<div class="text-center">Dostępna jest aktualizacja aplikacji. Zapisz bieżącą pracę i kliknij przycisk Aktualizuj poniżej. Możesz także zaakceptować te aktualizacje, odświeżając przeglądarkę w dowolnym momencie.<br />
              Brak aktualizacji może skutkować błędami.`
          }).then(result => {
              if (result.value) {
                  this.reloadApp();
              }
          });
        }
        return true;
      }

      return currentHash !== newHash;
    },
    reloadApp() {
      this.currentHash = this.newHash;
      // window.location.reload();
      window.location.href = window.location.href.split('?')[0] + '?t=' + new Date().getTime();
    }
  }
};